import { GetMenuItemsAvailableFilters } from "@/api/requests/getMenuItems";
import { CATEGORY_NAMES } from "@/constants/dispensary";

export const nestedFilterValuesByName = (
  filters: GetMenuItemsAvailableFilters,
  name: string,
) =>
  filters
    ?.find((option) => option.name === name)
    ?.values?.map((value) => value.value);

export const selectCategories = (
  availableFilters: GetMenuItemsAvailableFilters,
) => {
  const categories =
    nestedFilterValuesByName(availableFilters, "product_category") || [];

  const popularCategories = Object.keys(CATEGORY_NAMES).reduce(
    (list: string[], categoryName) => {
      const matchingCategory = categories?.find(
        (name) => categoryName === name,
      );
      return matchingCategory ? [...list, matchingCategory] : list;
    },
    [],
  );

  const otherCategories =
    categories?.filter((name) => !Object.keys(CATEGORY_NAMES).includes(name)) ||
    [];

  return [...popularCategories, ...otherCategories];
};
